import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import { Button, Card, CardBody, Col, Container, Row } from 'reactstrap';
import { CustomButton } from 'components/shared/CustomButton';
import { IGetOrderSummaryModel } from 'models/GetOrderSummary.Model';
import CommonService from 'services/CommonService';
import { ID_EncryptionKey, currencyByCountry, loadConfigforImageApiUrl, toAmount } from '../../helpers/Helper';
import { HelperConstant } from '../../helpers/HelperConstant';
import orderComplete from '../../assets/images/order-checkmark.png'
var CryptoJS = require("crypto-js");

function SuccessScreen() {
    const { encryptedId } = useParams<any>();
    const [successData, setSuccessData] = useState<IGetOrderSummaryModel>({} as IGetOrderSummaryModel);
    const [isReferral, setIsReferral] = useState<boolean>(false);
    const [cdnUrl, setCdnUrl] = useState("");

    const homePage = () => {
        // window.location.href = isRider() ? '/technicianhome' : '/HomePage';
        window.location.href = '/homepage';
    }
    useEffect(() => {
        const getOrderSummaryById = () => {
            CommonService.getWithSingleEntity("sell", "GetOrderSummary", encryptedId).then(response => {
                if (response.status === 200) {
                    setSuccessData(response.data);
                }
            }).catch((e: string) => {
                console.log(e);
            });
        }

        getOrderSummaryById();
    }, [encryptedId]);

    useEffect(() => {
        const fetchCdnUrl = async () => {
            const url = await loadConfigforImageApiUrl();
            setCdnUrl(url);
        };
        fetchCdnUrl();
    }, []);

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <div>
                        <h5 className="d-flex mb-3 fw-semibold text-dofy dofy-admin-font-md" style={{ whiteSpace: "nowrap" }}>ORDER COMPLETION</h5>
                    </div>
                    <Row className="justify-content-center mt-lg-0">
                        <Col xl={5} sm={8}>
                            <Card style={{ borderTop: '6px outset #1E4496' }}>
                                <CardBody>
                                    <div className="text-center">
                                        <Row className="justify-content-center">
                                            <Col lg={10}>
                                                <img src={orderComplete} alt="" />
                                                <h4 className="mt-2 fw-semibold ">THANK YOU FOR YOUR ORDER</h4>
                                                {/* <p className="text-muted mt-3 mb-0 mt-1 font-size-16 text-muted">Your Order is complete !</p> */}
                                                <p className="text-muted mt-3 mb-0 m-0 font-size-12 text-muted">You will be receiving a confirmation email with order details</p>
                                                <h4 className='m-0 text-dofy fw-bold mt-3 mb-0'>Order Id: {successData?.OrderCode || "--"}</h4>
                                                {/* <p className="text-muted mb-0 font-size-12 text-muted fw-semibold">Order Id </p> */}
                                                <div>
                                                    <img src={`${cdnUrl}/devicetypes/${successData.ProductTypeName}.png`} alt="" style={{ width: 90 }} className='' />
                                                    <p className='m-0 fw-semibold font-size-14'>{successData.BrandMasterName || ""}&nbsp;- {successData.SeriesModelName || ""}</p>
                                                    <p className='m-0 font-size-14'>{successData.ModelVariantName}</p>
                                                    <p className='mt-2 font-size-22 fw-bolder text-dofy m-0'>{currencyByCountry(toAmount(successData?.Payout?.TotalAmount || "0"))}/-</p>
                                                </div>
                                                <div className="mt-1">
                                                    <CustomButton type={'button'} btnClassName={'btn-success'} iconClasssName={undefined} name={'Back to Homepage'} onClick={homePage} />
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default SuccessScreen
